import {AbstractEvent} from "@/modules/base/events";
import {Match} from "@/modules/match/entity";

export class BeforeMatchProgressBallPositionEvent extends AbstractEvent {
  constructor(
    public match: Match,
    public ballPosition: number,
  ) {
    super();
  }
}